class ComplementaryProductsSlider extends HTMLElement {
  connectedCallback() {
    this.slider = this.querySelector('.swiper');
    this.addEventListener('click', this.onVariantChange.bind(this));
    this.addEventListener('keydown', this.onKeydown.bind(this));
    this.onOutsideClick = (event) => {
      if (!this.contains(event.target)) this.closeDropdowns();
    };
    document.addEventListener('click', this.onOutsideClick);
    this.addEventListener('click', this.onAddClick.bind(this));
    this.initSwiper();
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.onOutsideClick);
    this.swiper?.destroy(true, true);
    this.swiper = null;
  }

  initSwiper(attempt = 0) {
    if (!this.slider || this.swiper) return;
    if (typeof Swiper === 'undefined') {
      // Swiper loads deferred from the layout; retry shortly
      if (attempt < 20) setTimeout(() => this.initSwiper(attempt + 1), 100);
      return;
    }

    const root = this.closest('.cart-drawer__complementary') || this;
    const slideCount = this.slider.querySelectorAll('.swiper-slide').length;
    const single = slideCount <= 1;
    const dotsEl = this.slider.querySelector('.swiper-pagination');
    this.swiper = new Swiper(this.slider, {
      slidesPerView: single ? 1 : 1.1,
      spaceBetween: 12,
      pagination: !single && dotsEl ? { el: dotsEl, clickable: true } : false,

      navigation: {
        prevEl: root.querySelector('.slider-button--prev'),
        nextEl: root.querySelector('.slider-button--next'),
        disabledClass: 'disabled',
      },
    });
  }

  onVariantChange(event) {
    const trigger = event.target.closest('[data-variant-trigger]');
    const option = event.target.closest('[data-variant-option]');

    if (trigger) {
      const dropdown = trigger.closest('[data-variant-dropdown]');
      const willOpen = trigger.getAttribute('aria-expanded') !== 'true';
      this.closeDropdowns();
      if (willOpen) this.toggleDropdown(dropdown, true);
      return;
    }
    if (!option) return;

    const dropdown = option.closest('[data-variant-dropdown]');
    const card = option.closest('.card-product-horizontal');
    dropdown.querySelectorAll('[data-variant-option]').forEach((item) => {
      item.setAttribute('aria-selected', String(item === option));
    });
    dropdown.querySelector('[data-variant-label]').textContent = option.textContent.trim();
    this.toggleDropdown(dropdown, false);

    const addButton = card.querySelector('[data-add-to-cart]');
    addButton.dataset.variantId = option.dataset.value;
    addButton.dataset.preorder = option.dataset.preorder || 'false';
    card.querySelector('[data-price-display]').textContent = option.dataset.price;
    card.querySelector('[data-price-compare-display]').textContent = option.dataset.comparePrice || '';

    const image = card.querySelector('[data-variant-image]');
    if (image && option.dataset.image) image.src = option.dataset.image;
  }

  toggleDropdown(dropdown, open) {
    dropdown.querySelector('[data-variant-trigger]').setAttribute('aria-expanded', String(open));
    const list = dropdown.querySelector('[data-variant-list]');
    list.hidden = !open;
    if (open) this.positionDropdown(dropdown, list);
  }

  // Open below the trigger when there is room above the drawer footer, otherwise open upwards
  positionDropdown(dropdown, list) {
    dropdown.classList.remove('is-open-down');
    const trigger = dropdown.querySelector('[data-variant-trigger]');
    const footer = this.closest('cart-drawer')?.querySelector('.drawer__footer') || document.querySelector('.drawer__footer');
    const limit = footer ? footer.getBoundingClientRect().top : window.innerHeight;
    const spaceBelow = limit - trigger.getBoundingClientRect().bottom;
    if (spaceBelow >= list.offsetHeight + 8) dropdown.classList.add('is-open-down');
  }

  closeDropdowns() {
    this.querySelectorAll('[data-variant-dropdown]').forEach((dropdown) => this.toggleDropdown(dropdown, false));
  }

  onKeydown(event) {
    if (event.key === 'Escape') this.closeDropdowns();
    if ((event.key === 'Enter' || event.key === ' ') && event.target.matches('[data-variant-option]')) {
      event.preventDefault();
      event.target.click();
    }
  }

  onAddClick(event) {
    const button = event.target.closest('[data-add-to-cart]');
    if (!button || button.disabled) return;

    const cartDrawer = document.querySelector('cart-drawer');
    button.disabled = true;
    button.classList.add('is-loading');

    const item = {
      id: Number(button.dataset.variantId),
      quantity: 1,
      sections: 'cart-drawer,cart-icon-bubble',
      sections_url: window.location.pathname,
    };
    // Pre-order variants get the same line item property as the PDP (name from theme settings)
    if (button.dataset.preorder === 'true' && button.dataset.preorderProperty) {
      item.properties = { [button.dataset.preorderProperty]: 'Pre-order' };
    }
    const body = JSON.stringify(item);

    fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
      .then((response) => response.json())
      .then((parsedState) => {
        if (parsedState.status || !parsedState.sections) {
          button.disabled = false;
          button.classList.remove('is-loading');
          return;
        }
        cartDrawer.renderContents(parsedState);
      })
      .catch(() => {
        button.disabled = false;
        button.classList.remove('is-loading');
      });
  }
}

customElements.define('complementary-products-slider', ComplementaryProductsSlider);
